import { pipe, prop } from 'ramda';

export const nolSelector = prop('nol');
export const nolListSelector = pipe(nolSelector, prop('list'));
export const nolDetailSelector = pipe(nolSelector, prop('detail'));
